var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 184,
    viewBox: "0 0 182 184",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 5C62.7 4.6 82.5 22.5 91.5 31.5C84.6667 38.3333 67.1 49.4 51.5 39C32 26 46.5 5.5 55.5 5Z",
    stroke: "white",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127 5C119.8 4.6 100 22.5 91 31.5C97.8333 38.3333 115.4 49.4 131 39C150.5 26 136 5.5 127 5Z",
    stroke: "white",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 40,
    width: 174,
    height: 44,
    fill: "#2ECE6A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 88,
    width: 152,
    height: 90,
    fill: "#2ECE6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 87V176C168 178.761 165.761 181 163 181H18C15.2386 181 13 178.761 13 176V87H168Z",
    stroke: "white",
    strokeWidth: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 37,
    width: 176,
    height: 48,
    rx: 5,
    stroke: "white",
    strokeWidth: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 42,
    height: 82,
    rx: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 38,
    width: 42,
    height: 46,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsVault);
export default __webpack_public_path__ + "static/media/rewards-vault.78b7d404561364e8273169fe90f4e1d7.svg";
export { ForwardRef as ReactComponent };